module.exports = __webpack_public_path__ + "img/F-keys.a9d0b8a6.png";